// extracted by mini-css-extract-plugin
export default {"tips":"Tip-module__tips___1Qg8I","percent":"Tip-module__percent___1L4L7","dollars":"Tip-module__dollars___9G75x"};